import Link from 'next/link';
import Image from 'next/image';
import { MENU_LINKS } from '@/shared/constants';
import { useEffect, useState } from 'react';
import { productSans } from '@/constants/fonts';

type HeaderProps = {
  sticky?: boolean;
  hideMenu?: boolean;
};

export default function Header(props: HeaderProps) {
  const { sticky = true, hideMenu = false } = props;

  const [isAtTop, setIsAtTop] = useState(true);
  const [openDropDownMenu, setOpenDropDownMenu] = useState<boolean>(false);

  useEffect(() => {
    if (sticky) return;
    const onScroll = () => setIsAtTop(document.documentElement.scrollTop === 0);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, [sticky]);

  return (
    <div
      className={`${sticky ? 'sticky' : 'fixed'} ${!sticky && !openDropDownMenu && isAtTop ? 'bg-transparent' : 'bg-gray-900'} top-0 z-[1000] w-screen transition-colors duration-500 ${productSans.className}`}
    >
      <div className="relative z-20 mx-auto flex w-full max-w-[1440px] flex-row items-center justify-between px-4 py-2.5">
        <Link href={'/'} className="relative h-[52px] w-[52px]">
          <Image src="/images/logo.svg" alt="logo" fill />
        </Link>
        {!hideMenu && (
          <div className="hidden gap-8 *:ml-12 lg:flex">
            {MENU_LINKS.map((link, index) => (
              <Link
                key={`menu-item-${index}`}
                className="text-[22px] text-white opacity-80 transition-colors hover:text-[#C60C93] hover:opacity-100"
                href={link.href}
              >
                {link.title}
              </Link>
            ))}
          </div>
        )}
        {!hideMenu && (
          <div
            className="flex aspect-square w-[40px] flex-col items-center justify-center gap-1 rounded-full bg-white lg:hidden"
            onClick={() => {
              setOpenDropDownMenu((v) => !v);
            }}
          >
            <div className="h-[3px] w-[22px] rounded-md bg-gray-900" />
            <div className="h-[3px] w-[22px] rounded-md bg-gray-900" />
            <div className="h-[3px] w-[22px] rounded-md bg-gray-900" />
          </div>
        )}
      </div>
      <div
        className={`absolute top-[72px] right-0 left-0 z-10 flex w-screen flex-col items-center justify-center bg-gray-900 py-10 transition-all duration-400 ease-in-out lg:hidden ${openDropDownMenu ? 'transform-[translateY(0)]' : 'transform-[translateY(-200%)]'}`}
      >
        {MENU_LINKS.map((link, index) => (
          <Link
            key={`menu-item-${index}`}
            href={link.href}
            onClick={() => setOpenDropDownMenu(false)}
            className="w-full border-b border-white px-8 py-3 text-left font-light text-white last:border-0"
          >
            {link.title}
          </Link>
        ))}
      </div>
    </div>
  );
}
